"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18 13h3v2h-3zm-6-1v2h-2v4h2v2h5v-8z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5 11h7V4H4v2h6v3H3v8h6v-2H5zm13 6h3v2h-3z"
}, "1")], 'ElectricalServicesSharp');